import { render } from "./DispatchDetailsModal.vue?vue&type=template&id=53eb117f&scoped=true"
import script from "./DispatchDetailsModal.vue?vue&type=script&lang=js"
export * from "./DispatchDetailsModal.vue?vue&type=script&lang=js"

import "./DispatchDetailsModal.vue?vue&type=style&index=0&id=53eb117f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53eb117f"]])

export default __exports__